// api/user.ts
import request from "@/utils/request";

export type SubnetData = {
  data_time: string; // 格式: "YYYY-MM-DD HH:mm:ss"
  first_time: string;
  last_first_time: string;
  last_liquidity: number;
  last_market_cap: number;
  last_price: number;
  liquidity: number;
  liquidity_change_rate: number;
  market_cap: number;
  market_cap_change_rate: number;
  max_apy: number;
  apy_1t1b: number;
  netid: number;
  price: number;
  price_change_rate: number;
  subnet_name: string;
  subnet_symbol: string;
};

export type SubnetDetail = {
  alpha_stake: number; // 格式: "YYYY-MM-DD HH:mm:ss"
  avg_apy: number;
  curr_apy: number;
  hotkey: string;
  last_alpha_stake: number;
  validator_name: string;
};
type StakeInfo = {
  rao: number;
  tao: number;
};
export type StakeData = {
  netuid: number;
  coldkey: string;
  hotkey: string;
  stake: StakeInfo;
};
export type listItem = { label: string; value: number };
export function fetchSubnetList(time: string): Promise<SubnetData[]> {
  return request.get(`/subnets/${time}`);
}

export function fetchStakeData(account: string): Promise<StakeData[]> {
  return request.get(`/account/${account}`);
}

export function fetchSubnetDetail(
  netid: number,
  time: string
): Promise<SubnetDetail[]> {
  return request.get(`/subnets/details/${netid}?duration=${time}`);
}

// POST 示例
export function login(data: { username: string; password: string }) {
  return request.post("/auth/login", data);
}
